import React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from '../../utils/LanguageContext';

const SearchHelp = () => {
  const { t } = useTranslation();
  
  return (
    <div className="relative group">
      <QuestionMarkCircleIcon className="h-5 w-5 text-gray-400 hover:text-gray-600 cursor-help" />
      <div className="hidden group-hover:block absolute right-0 top-full mt-2 w-96 p-4 bg-white rounded-lg shadow-lg text-sm text-gray-600 z-10 border border-gray-200">
        <ul className="space-y-2">
          <li>• Use <span className="font-semibold">AND</span> or <span className="font-semibold">|</span> to combine terms</li>
          <li>• Use quotes for exact phrases: <span className="font-mono text-xs">"Environment Setup"</span></li>
          <li>• Use <span className="font-mono text-xs">**text**</span> for exact matches</li>
          <li>• Use abbreviated terms: <span className="font-mono text-xs">repandworpro</span> for "Reporting and Work Procedures"</li>
          <li>• Search includes module codes, names, objectives, skills, and prerequisites</li>
          <li>• Not case sensitive</li>
          <li className="pt-2 border-t border-gray-200 mt-2">
            <span className="font-semibold">Examples:</span><br />
            <span className="font-mono text-xs">repandworpro|prodevandqua</span><br />
            <span className="font-mono text-xs">"Introduction"|"Reporting and Work Procedures"</span><br />
            <span className="font-mono text-xs">intro|report</span><br />
            <span className="font-mono text-xs">**Introduction** AND Quality</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SearchHelp;